import { render, staticRenderFns } from "./SearchByPlateComponent.vue?vue&type=template&id=5071c8aa"
import script from "./SearchByPlateComponent.vue?vue&type=script&lang=js"
export * from "./SearchByPlateComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchByPlateComponent.vue?vue&type=style&index=0&id=5071c8aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports